import React, { useEffect, useState } from 'react'
import CurrencyTypeView from '../../../../itrust_common/components/others/CurrencyTypeView'
import { getCardBrandImg, getPaymentMethodLabel, humanize } from '../../../../itrust_common/components/HelperFunctions'
import Moment from 'moment';
import { DatePicker } from 'react-widgets';
import TruncateText from '../../../../itrust_common/components/others/TruncateText';
import { AutoCompleteSelect, Input } from '../../../../itrust_common/components/form';
import { Field, reduxForm } from 'redux-form';
import { orderPaymentUpdate } from '../../../../redux/actions/order/orderPaymentActions';
import { connect, useDispatch } from 'react-redux';
import useOrgDateFormat from '../../../../itrust_common/components/others/helperHooks/useOrgDateFormat';

function SaleRefundPaymentForm(props) {
  const { payment, orderStoreId, orderId, providers, setEditPayment, NonOnlinePaymentMethods } = props
  const dispatch = useDispatch()
  const dateFormatType = useOrgDateFormat()

  const [editInfo, setEditInfo] = useState({
    id: payment.id,
    mode_of_payment: payment.mode_of_payment,
    payment_date: payment.payment_date,
    card_details: payment.card_details,
    check_details: payment.check_details,
    staff_id: payment.staff_attributes?.id
  })

  useEffect(() => {
    return () => {
      setEditInfo({})
    }
  }, [])

  const handlePaymentUpdate = async () => {
    let data = {
      ...editInfo,
      // check_details: { check_number: editInfo.mode_of_payment == 'check' ? editInfo.check_details.check_number : '' },
      card_details: { card_type: editInfo.mode_of_payment == 'card' ? editInfo.card_details?.card_type : '' }
    }
    await dispatch(orderPaymentUpdate(orderId, data, { include: ['staff'] }))
    setEditPayment({})
  }

  return (
    <tr className="text-dark border-bottom border-light border-bottom-2">
      <td className="text-center">#{payment.id}</td>
      <td>
        <CurrencyTypeView amount={payment.amount} />
        {payment.online_payment_details?.card_type && <span className='ml-5'>
          {getCardBrandImg(payment.online_payment_details.card_type, 'mx-1')}
          {payment.online_payment_details.last4digit}
        </span>}
      </td>
      <td>
        <select className="form-control form-control-sm width-5" value={editInfo.mode_of_payment} onChange={(e) => setEditInfo({ ...editInfo, mode_of_payment: e.target.value })}>
          {NonOnlinePaymentMethods.map((item) => <option value={item.value} key={item.value}>{getPaymentMethodLabel(item.value)}</option>)}
        </select>
      </td>
      <td className='min-width-11'>
        <DatePicker
          value={editInfo.payment_date ? new Date(editInfo.payment_date.replace(/-/g, '\/')) : null}
          format={dateFormatType}
          editFormat={dateFormatType}
          placeholder={dateFormatType}
          onChange={(date) => setEditInfo({ ...editInfo, payment_date: Moment(date).format("YYYY/MM/DD") })}
        />
      </td>
      <td>
        {editInfo.mode_of_payment === 'check' ? <Field
          component={Input}
          name="check_details[check_number]"
          value={editInfo.check_details?.check_number}
          onChange={(e) => setEditInfo({ ...editInfo, check_details: { check_number: e.target.value } })}
          className='form-control form-control-sm'
        /> : ''
        }
      </td>
      <td>
        {editInfo.mode_of_payment === 'card' ? <Field
          valueField="name"
          textField="name"
          klass="StoreSetting"
          hideResetButton={true}
          name="card_details[card_type]"
          component={AutoCompleteSelect}
          wrapperClasses="filter-multiselect width-7"
          onChangeHook={(data) => setEditInfo({ ...editInfo, card_details: { card_type: data.name } })}
          additionalFilters={{ category: 'card_types', is_archived: false, store_id: Number(localStorage.getItem('StoreID')) || orderStoreId }}
          initialValue={{ card_details: payment.card_details }}
          displayName="card_details[card_type]"
        /> : ''}
      </td>
      <td>
        <select className="form-control form-control-sm width-7" value={editInfo?.staff_id} onChange={(e) => setEditInfo({ ...editInfo, staff_id: e.target.value })}>
          {providers.map((item) => <option value={item.id} key={item.id}>{item.name}</option>)}
        </select>
      </td>
      <td>
        <TruncateText textCount={10}>
          {payment.notes}
        </TruncateText>
      </td>
      <td className='d-flex align-items-center'>
        <button type='button' className='btn btn-primary btn-sm px-3 py-1' onClick={() => handlePaymentUpdate()}>Save</button>
        <span className='text-primary pointer pl-4' onClick={() => setEditPayment({})}><i className='las la-times font-size-16' /></span>
      </td>
    </tr>
  )
}

SaleRefundPaymentForm = reduxForm({
  form: 'SaleRefundPaymentForm',
  enableReinitialize: true
})(SaleRefundPaymentForm);

const mapStateToProps = (state) => {
  const { order: { order }, currentStore } = state
  return {
    orderId: order.id,
    orderStoreId: order.store_id,
    providers: currentStore.staffs
  }
}

export default connect(mapStateToProps)(SaleRefundPaymentForm);